import instance from './instance'

const reportUrl = 'modules-lead/report'

export interface ReportFilterParams {
  start_date?: string
  end_date?: string
  min_point?: number | ''
  max_point?: number | ''
  min_money?: number | ''
  max_money?: number | ''
  client_id?: string
  status?: string
  action_id?: number | ''
  page?: number
  pageSize?: number
}

export const getReportList = (params: ReportFilterParams) =>
  instance.get(`${reportUrl}`, {params})

export const exportReportExcel = (params: ReportFilterParams) =>
  instance.get(`${reportUrl}/export-excel`, {params})
